module.exports = "//public.getcloudapp.com/packs/media/images/icons-square-corners-8567db87a47536cf1d1446d385619942.svg";